import React, { useEffect, useState } from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsEye, BsThreeDots } from "react-icons/bs";
import { FiEdit, FiPlusCircle } from "react-icons/fi";
import { ImCross } from "react-icons/im";
import { BiLockOpen } from "react-icons/bi";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  Link,
  Box,
} from "@chakra-ui/react";
import { IrmaosEditar } from "../Editar";
import { ComunitariaEditar } from "../../Comunitaria/Editar";
import { GuardaEditar } from "../../Guarda/Editar";
import {
  Permission,
  criancaFunc,
  referenciaFunc,
  vrCriancaFunc,
} from "../../../../../../helpers/Funcionalidades";
import TablePagination from "../../../../../components/TablePagination";
import { RestricoesEditar } from "../../../Visita/Visitas/Restricoes/Editar";
import { SituacaoJuridicaEditar } from "../../../SituacaoJuridica/SituacoesJuridicas/Editar";
import { normalizeString } from "../../../../../utils/masks";
import { EntregaVoluntariaModal } from "../../../SituacaoJuridica/EntregaVoluntaria/Cadastrar/EntregaVoluntariaModal";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { useAuthProvider } from "../../../../../../Context/AuthProvider";
import { CadastrarMovimentacaoModal } from "../../../Movimentacao/Cadastrar";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { useHistory } from "react-router";

export const IrmaoTable = ({
  data,
  columns,
  filiacoes,
  setFieldValue,
  comunitaria,
  guarda,
  irmaos,
  deleteIrmaos,
  entidade,
  deleteReferencia,
  deleteProcessoProcedimento,
  deleteEntregaVoluntaria,
  deleteGuarda,
  deleteRestricoes,
  idCrianca,
  fetchReferenciaData,
  fetchIrmaosData,
  fetchDataGuarda,
  fetchVisitasData,
  fetchDataRestricoes,
  visitas,
  visitasImprimir,
  restricoes,
  disableHeaderOptions,
  disableHeaderOptionsOpcoes,
  disableHeaderOptionsPagination,
  mt,
  processos,
  procedimentos,
  fetchProcessosProcedimentoData,
  fetchEntregaVoluntaria,
  fetchAtribuicao,
  props,
  entrega,
  entregaCadastrar,
  dataVoluntariaCadastrar,
  cpfBlocked,
  setCpfBlocked,
  duplicidade,
  dataIrmaos,
  dataReferencia,
  isOpenNovoAcolhimento,
  onOpenNovoAcolhimento,
  onCloseNovoAcolhimento,
  idPJ,
  isPrint,
}) => {
  const history = useHistory();
  const { setIrmaoCadatrar } = useAppContext();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isEdicao, setIsEdicao] = useState(false);

  const [isLiberar, setIsLiberar] = useState(false);
  const [isLiberarEdit, setIsLiberarEdit] = useState(false);
  const [selectedFiliacao, setSelectedFiliacao] = useState();
  const [nItens, setNItens] = useState(isPrint ? 9999999 : 10);
  const { roleKeycloack, user } = useAuthProvider();
  const [idRelacionamento, setIdRelacionamento] = useState(0);

  const [criancaId, setCriancaId] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");

  const showItensRestricoes =
    roleKeycloack?.includes(vrCriancaFunc.restricaoExcluir) ||
    roleKeycloack?.includes(vrCriancaFunc.restricaoEditar) ||
    roleKeycloack?.includes(vrCriancaFunc.restricaoLiberar);

  const columnsEntregaCadastrar = [
    {
      Header: "Nº do Processo/Procedimento",
      accessor: "numeroProcesso",
      Cell: (props) => {
        return (
          <Flex alignItems="center" gap={2} whiteSpace={"nowrap"}>
            <RadioButtonField
              fieldName={
                duplicidade ? "idPessoaFisica" : "idProcessoProcedimento"
              }
              value={`${props.row.original.id}`}
              label=""
            />

            <span title={props.value}>{props.value}</span>
          </Flex>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
    },
  ];

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    gotoPage,
    pageOptions,
    page,
    canPreviousPage,
    previousPage,
    canNextPage,
    nextPage,
    pageCount,
    setPageSize,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: irmaos
          ? [
              {
                id: "situacao",
                desc: false,
              },
            ]
          : entidade === "apadrinhamento"
            ? [
                {
                  id: "dataInicioApadrinhamento",
                  desc: true,
                },
                {
                  id: "dataFimApadrinhamento",
                  desc: true,
                },
              ]
            : [],
        pageSize: nItens,
      },
      manualPagination: entidade === "crianca" ? true : false,
      pageCount: JSON.parse(sessionStorage.getItem(entidade + "-filter"))
        ?.totalPages,
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,

    (hooks) => {
      !visitas &&
        !disableHeaderOptions &&
        !disableHeaderOptionsOpcoes &&
        (((processos || procedimentos) &&
          roleKeycloack.includes(criancaFunc.editarPP)) ||
          roleKeycloack.includes(criancaFunc.visualizarPP) ||
          roleKeycloack.includes(criancaFunc.excluirPP) ||
          (entrega &&
            (roleKeycloack.includes(criancaFunc.editarVoluntaria) ||
              roleKeycloack.includes(criancaFunc.excluirVoluntaria)))) &&
        hooks.visibleColumns.push((columns) => [
          ...columns,
          {
            id: "moreInfo",
            Header: "Opções",
            Cell: ({ row }) => (
              <Flex justifyContent="center">
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<BsThreeDots color="#fff" fontSize="20px" />}
                    variant={"link"}
                    cursor={"pointer"}
                    backgroundColor="#95BCBF"
                    rounded={100}
                    p={2}
                  />

                  <MenuList
                    display={!showItensRestricoes && restricoes ? "none" : ""}
                  >
                    {row.original.nome !== "Desconhecido" &&
                      row.original.nome !== "Desconhecida" &&
                      normalizeString(row.original.nome) !==
                        normalizeString("Sem informação") && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={
                            guarda
                              ? referenciaFunc.guardaAlterar
                              : comunitaria
                                ? referenciaFunc.referenciaAlterar
                                : restricoes
                                  ? vrCriancaFunc.restricaoEditar
                                  : irmaos
                                    ? referenciaFunc.irmaoAlterar
                                    : processos || procedimentos
                                      ? criancaFunc.editarPP
                                      : entrega
                                        ? criancaFunc.editarVoluntaria
                                        : ""
                          }
                          id={
                            irmaos ||
                            comunitaria ||
                            vrCriancaFunc.restricaoEditar
                              ? idPJ
                              : null
                          }
                          user={user}
                          visualizar={
                            vrCriancaFunc.restricaoEditar ? false : true
                          }
                        >
                          {!guarda &&
                            (!row.original.situacao ||
                              row.original.situacao ===
                                "Sem histórico de acolhimento" ||
                              row.original.situacao === "Desligado") && (
                              <MenuItem
                                p={2}
                                color={"#374BCE"}
                                onClick={() => {
                                  if (!guarda && !restricoes) {
                                    if (
                                      irmaos ||
                                      processos ||
                                      procedimentos ||
                                      entrega
                                    ) {
                                      setSelectedFiliacao(row.original);
                                    } else {
                                      setSelectedFiliacao(
                                        row.original
                                          .pessoaFisicaReferenciaFamiliarComunitaria,
                                      );
                                    }

                                    setIsEdicao(false);
                                  } else {
                                    setSelectedFiliacao(row.original);
                                  }

                                  setIdRelacionamento(
                                    row.original.idRelacionamento,
                                  );

                                  if (row.original.status === "Proibido") {
                                    setIsEdicao(true);
                                    setIsLiberar(false);
                                    setIsLiberarEdit(false);
                                  } else {
                                    setIsEdicao(false);
                                    setIsLiberarEdit(true);
                                    setIsLiberar(true);
                                  }

                                  onOpen();
                                }}
                              >
                                <FiEdit />
                                <Text ml="5px">Editar</Text>
                              </MenuItem>
                            )}
                        </Permission>
                      )}
                    {irmaos && row.original.situacao === "Desligado" ? (
                      <Link
                        color={"#374BCE"}
                        _hover={{ textDecoration: "none" }}
                        onClick={() => {
                          setCriancaId(row.original.idCrianca);
                          setDataNascimento(row.original.dataNascimento);
                          onOpenNovoAcolhimento();
                        }}
                      >
                        <MenuItem p={2} color={"#374BCE"}>
                          <FiPlusCircle />
                          <Text ml="5px">Novo Acolhimento</Text>
                        </MenuItem>
                      </Link>
                    ) : (
                      ""
                    )}

                    {restricoes && row.original.status === "Proibido" ? (
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={restricoes ? vrCriancaFunc.restricaoLiberar : ""}
                      >
                        <MenuItem
                          p={2}
                          color={"#374BCE"}
                          onClick={() => {
                            if (!guarda) {
                              setSelectedFiliacao(row.original);
                            } else {
                              setSelectedFiliacao(row.original);
                            }

                            setIdRelacionamento(row.original.idRelacionamento);
                            setIsEdicao(true);
                            setIsLiberar(true);
                            onOpen();
                          }}
                        >
                          <BiLockOpen size={15} />
                          <Text ml="5px">Liberar</Text>
                        </MenuItem>
                      </Permission>
                    ) : (
                      ""
                    )}

                    {!guarda &&
                      !restricoes &&
                      !visitas &&
                      !visitasImprimir &&
                      !entrega && (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={
                            processos || procedimentos
                              ? criancaFunc.visualizarPP
                              : comunitaria
                                ? referenciaFunc.referenciaVisualizarDetalhe
                                : ""
                          }
                          id={comunitaria ? idPJ : null}
                          user={user}
                          visualizar={true}
                        >
                          <MenuItem
                            p={2}
                            color={"#374BCE"}
                            onClick={() => {
                              if (irmaos || processos || procedimentos) {
                                setSelectedFiliacao(row.original);
                              } else {
                                setSelectedFiliacao(
                                  row.original
                                    .pessoaFisicaReferenciaFamiliarComunitaria,
                                );
                              }
                              setIdRelacionamento(
                                row.original.idRelacionamento,
                              );
                              setIsEdicao(true);
                              onOpen();
                            }}
                          >
                            <BsEye />
                            <Text ml="5px">Visualizar</Text>
                          </MenuItem>
                        </Permission>
                      )}

                    {irmaos &&
                    row.original.situacao === "Sem histórico de acolhimento" ? (
                      <Permission
                        roleKeycloack={roleKeycloack}
                        func={criancaFunc.cadastrar}
                      >
                        <MenuItem
                          p={2}
                          color={"#374BCE"}
                          onClick={() => {
                            setIrmaoCadatrar(row.original);
                            history.push(`/crianca/cadastrar?acao=true`);
                          }}
                        >
                          <FiPlusCircle />
                          <Text ml="5px">Cadastrar Acolhimento</Text>
                        </MenuItem>
                      </Permission>
                    ) : (
                      ""
                    )}

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={
                        guarda
                          ? referenciaFunc.guardaExcluir
                          : comunitaria
                            ? referenciaFunc.referenciaExcluir
                            : restricoes
                              ? vrCriancaFunc.restricaoExcluir
                              : irmaos
                                ? referenciaFunc.irmaoExcluir
                                : processos || procedimentos
                                  ? criancaFunc.excluirPP
                                  : entrega
                                    ? criancaFunc.excluirVoluntaria
                                    : ""
                      }
                      id={irmaos || comunitaria || guarda ? idPJ : null}
                      user={user}
                      visualizar={true}
                    >
                      {(irmaos &&
                        row.original.situacao !==
                          "Sem histórico de acolhimento") ||
                      ((processos || procedimentos) &&
                        row.original.extincaoPoderFamilia &&
                        (row.original.extincaoPoderFamilia === "S" ||
                          row.original.extincaoPoderFamilia === "N")) ? (
                        ""
                      ) : (
                        <MenuItem
                          p={2}
                          color={"red.500"}
                          onClick={() => {
                            guarda
                              ? deleteGuarda(row.original.idGuarda, onClose)
                              : comunitaria
                                ? deleteReferencia(
                                    row.original.idRelacionamento,
                                    onClose,
                                  )
                                : restricoes
                                  ? deleteRestricoes(
                                      row.original.idRestricao,
                                      onClose,
                                    )
                                  : irmaos
                                    ? deleteIrmaos(
                                        idCrianca,
                                        onClose,
                                        row.original.pessoaFisicaIrmao
                                          .idPessoaFisica,
                                      )
                                    : processos || procedimentos
                                      ? deleteProcessoProcedimento(
                                          row.original.id,
                                          row.original.compartilharProcesso,
                                          onClose,
                                        )
                                      : entrega
                                        ? deleteEntregaVoluntaria(
                                            row.original.id,
                                            onClose,
                                          )
                                        : console.log("Error");
                          }}
                        >
                          <ImCross />
                          <Text ml="5px">Excluir</Text>
                        </MenuItem>
                      )}
                    </Permission>
                  </MenuList>
                </Menu>
              </Flex>
            ),
          },
        ]);
    },
  );

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-pagination-count")) {
      setNItens(
        parseInt(sessionStorage.getItem(entidade + "-pagination-count")),
      );
    }
  }, [entidade]);

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-pagination-page")) {
      const tempPage = Number(
        sessionStorage.getItem(entidade + "-pagination-page"),
      );
      if (tempPage <= pageCount) {
        gotoPage(tempPage);
      }
    }
  }, [state, entidade, gotoPage, pageCount]);

  function irParaPagina(pagina) {
    sessionStorage.setItem(entidade + "-pagination-page", pagina);
    gotoPage(pagina);
  }

  function selecionarTotalItens(nItens) {
    sessionStorage.setItem(entidade + "-pagination-count", nItens);
    setPageSize(nItens);
  }

  return (
    <Flex flexDir="column" overflowX={"auto"}>
      <Table {...getTableProps} backgroundColor="white" mt={mt ? mt : "5px"}>
        <Thead backgroundColor="#ECEFF1">
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps({
                    ...column.getHeaderProps(
                      !(column.Header === "Opções") &&
                        column.getSortByToggleProps({ title: undefined }),
                    ),
                  })}
                  key={index}
                  width={`${
                    entidade === "referencia-comunitaria"
                      ? column.Header === "Endereço"
                        ? "413px"
                        : ""
                      : entregaCadastrar &&
                          column.Header === "Nº do Processo/Procedimento"
                        ? "100px"
                        : entidade === "apadrinhamento" &&
                            column.Header === "Nome"
                          ? "250px"
                          : entidade === "pendencias" &&
                              column.Header === "Pendências"
                            ? "50%"
                            : ""
                  }`}
                >
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent={
                      column.Header === "Opções" ? "center" : "flex-start"
                    }
                  >
                    <Text
                      as="p"
                      whiteSpace={{
                        base:
                          column.Header === "Serviço de Acolhimento Atual"
                            ? entidade === "relatorio-servico-acolhimento"
                              ? "nowrap"
                              : "normal"
                            : "nowrap",
                        lg:
                          column.Header === "Nº do Processo" ||
                          column.Header === "Nº do Procedimento" ||
                          column.Header === "Decisão Judicial" ||
                          column.Header === "Nº do Processo/Procedimento" ||
                          column.Header === "Data Início" ||
                          column.Header === "Data Fim"
                            ? "nowrap"
                            : "normal",
                      }}
                    >
                      {column.render("Header")}
                    </Text>

                    {column.canSort ? (
                      <Flex pl={1} alignItems="center">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Icon as={FaSortDown} boxSize="14px" />
                          ) : (
                            <Icon as={FaSortUp} boxSize="14px" />
                          )
                        ) : (
                          <Icon as={FaSort} boxSize="14px" />
                        )}
                      </Flex>
                    ) : (
                      ""
                    )}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <Td
                      key={index}
                      {...cell.getCellProps()}
                      py="6px"
                      fontWeight={500}
                      fontSize="14px"
                      lineHeight="21.6px"
                      borderBottom={"solid"}
                      color="#797A80"
                    >
                      {cell.render("Cell")}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      {selectedFiliacao && irmaos && (
        <IrmaosEditar
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={() => {
            setSelectedFiliacao(null);
            onClose();
          }}
          filiacoes={data}
          idCrianca={idCrianca}
          updateFromVisualizacao={true}
          selectedFiliacao={selectedFiliacao}
          isVisualizacao={isEdicao}
          fetchIrmaosData={fetchIrmaosData}
          setFieldValue={setFieldValue}
          roleKeycloack={roleKeycloack}
          dataIrmaos={dataIrmaos && dataIrmaos}
          idPJ={idPJ}
        />
      )}

      {irmaos && (
        <CadastrarMovimentacaoModal
          isOpen={isOpenNovoAcolhimento}
          onOpen={onOpenNovoAcolhimento}
          data={data}
          fetchFunc={fetchIrmaosData}
          onOpenNovoAcolhimento={onOpenNovoAcolhimento}
          movimentoDefault={true}
          idCrianca={criancaId}
          table={true}
          dataNascimento={dataNascimento}
          onClose={() => {
            onCloseNovoAcolhimento();
          }}
          roleKeycloack={roleKeycloack}
          user={user}
          idPJ={idPJ}
        />
      )}
      {selectedFiliacao && entrega && (
        <EntregaVoluntariaModal
          isOpen={isOpen}
          onOpen={onOpen}
          idCrianca={idCrianca}
          dataVoluntaria={[selectedFiliacao]}
          data={dataVoluntariaCadastrar}
          columnsEntregaCadastrar={columnsEntregaCadastrar}
          onClose={() => {
            setSelectedFiliacao(null);
            onClose();
          }}
          buttonText={"Editar"}
          roleKeycloack={roleKeycloack}
          fetchEntregaVoluntaria={fetchEntregaVoluntaria}
        />
      )}
      {selectedFiliacao && comunitaria && (
        <ComunitariaEditar
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={() => {
            setSelectedFiliacao(null);

            onClose();
          }}
          filiacoes={data}
          idCrianca={idCrianca}
          updateFromVisualizacao={true}
          selectedFiliacao={selectedFiliacao}
          isVisualizacao={isEdicao}
          fetchReferenciaData={fetchReferenciaData}
          fetchDataGuarda={fetchDataGuarda}
          idRelacionamento={idRelacionamento}
          roleKeycloack={roleKeycloack}
          user={user}
          idPJ={idPJ}
          cpfBlocked={cpfBlocked}
          setCpfBlocked={setCpfBlocked}
          dataReferencia={dataReferencia && dataReferencia}
        />
      )}

      {selectedFiliacao && guarda && (
        <GuardaEditar
          isOpen={isOpen}
          onOpen={onOpen}
          idCrianca={idCrianca}
          onClose={() => {
            setSelectedFiliacao(null);

            onClose();
          }}
          filiacoes={data}
          updateFromVisualizacao={true}
          selectedFiliacao={selectedFiliacao}
          isVisualizacao={!isEdicao}
          fetchDataGuarda={fetchDataGuarda}
          roleKeycloack={roleKeycloack}
        />
      )}

      {selectedFiliacao && restricoes && (
        <RestricoesEditar
          isOpen={isOpen}
          onOpen={onOpen}
          idCrianca={idCrianca}
          onClose={() => {
            setSelectedFiliacao(null);

            onClose();
          }}
          filiacoes={data}
          updateFromVisualizacao={true}
          selectedFiliacao={selectedFiliacao}
          isVisualizacao={!isEdicao}
          isLiberar={isLiberar}
          isLiberarEdit={isLiberarEdit}
          fetchDataRestricoes={fetchDataRestricoes}
          roleKeycloack={roleKeycloack}
        />
      )}

      {selectedFiliacao && (processos || procedimentos) && (
        <SituacaoJuridicaEditar
          isOpen={isOpen}
          onOpen={onOpen}
          idCrianca={idCrianca}
          onClose={() => {
            setSelectedFiliacao(null);

            onClose();
          }}
          filiacoes={data}
          updateFromVisualizacao={true}
          selectedFiliacao={selectedFiliacao}
          isVisualizacao={isEdicao}
          roleKeycloack={roleKeycloack}
          fetchProcessosProcedimentoData={fetchProcessosProcedimentoData}
          fetchAtribuicao={fetchAtribuicao}
        />
      )}
      {entrega && (
        <Text color="red" opacity={0.8} mt={2} fontSize="12px">
          {duplicidade
            ? props?.errors?.idPessoaFisica
            : props?.errors?.idProcessoProcedimento}
        </Text>
      )}

      <Flex gap={10} mt="2">
        {entidade === "relatorio-crianca-adolescente-geral" && isPrint && (
          <Flex alignItems="center" gap={1}>
            <Box
              w="4"
              h="4"
              bg="#169499"
              borderRadius="full"
              border="1px"
              color="#169499"
            />
            <Text>Em Transferência</Text>
          </Flex>
        )}

        {entidade === "relatorio-crianca-adolescente-geral" && isPrint && (
          <Flex alignItems="center" gap={1}>
            <Box
              w="4"
              h="4"
              bg="red"
              borderRadius="full"
              border="1px"
              color="red"
            />
            <Text>Pendência por Maioridade</Text>
          </Flex>
        )}
      </Flex>

      {!guarda && !disableHeaderOptions && !disableHeaderOptionsPagination && (
        <TablePagination
          nItens={nItens}
          selecionarTotalItens={selecionarTotalItens}
          irParaPagina={irParaPagina}
          pageSize={state.pageSize}
          setPageSize={setPageSize}
          rows={rows}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          pageOptions={pageOptions}
          pageIndex={state.pageIndex}
          canNextPage={canNextPage}
          nextPage={nextPage}
          pageCount={pageCount}
        />
      )}
    </Flex>
  );
};
